import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { tasksListLayoutRoute } from '..';
import { DEFAULT_TASK_TAB, TASK_TABS, TaskTab } from './types';

const isTaskTab = (value: string): value is TaskTab => TASK_TABS.includes(value as TaskTab);

export const tasksIndexRoute = createRoute({
  getParentRoute: () => tasksListLayoutRoute,
  path: '/',
  beforeLoad: () =>
    redirect({ to: '/finance/tasks/$taskType', params: { taskType: DEFAULT_TASK_TAB } }),
});

export const tasksListRoute = createRoute({
  getParentRoute: () => tasksListLayoutRoute,
  path: '$taskType',
  parseParams: ({ taskType }) => ({
    taskType: isTaskTab(taskType) ? taskType : DEFAULT_TASK_TAB,
  }),
  validateSearch: z.object({
    q: z.string().optional(),
  }).parse,
  component: lazyRouteComponent(() => import('./TasksListView')),
});
